import ApplicationController from './application_controller';
import { loadJQueryDataTables } from '../lib/datatables/load_jquery_datatables';

export default class extends ApplicationController {
  static targets = ['serviceHistoryDataTable'];

  async serviceHistoryDataTableTargetConnected(target) {
    await loadJQueryDataTables();
    if (!target.isConnected) return;

    if (window.$.fn.dataTable.isDataTable('#service-history-table')) {
      window.$('#service-history-table').DataTable().destroy();
    }
    window.$('#service-history-table').DataTable({
      order: [[0, 'desc']],
    });
  }
}
